import JSCookie from 'js-cookie';
import moment from 'moment';
import UserService from './../services/UserService'

export const FORTHING_MEMBER_PARENT = 1200;
export const FORTHING_MEMBER_CHILD  = 1201;
export const FORTHING_MEMBER_SUPPORT_PARENT = 1210;
export const FORTHING_MEMBER_SUPPORT_CHILD  = 1211;
export const GENERAL_FREE_MEMBER_PARENT = 2100;
export const GENERAL_FREE_MEMBER_CHILD  = 2101;
export const PROGRESS_MEMBER_PARENT = 4000;
export const PROGRESS_MEMBER_CHILD = 4001;

export default new class {
    constructor() {
        this.authData = null;
        this.cookieName = 'App-Authorization';
    }

    isAuth() {
        if (this.authData && this.authData.token && this.authData.expiration > moment().valueOf()) {
            return true;
        } else {
            const authDataStr = JSCookie.get(this.cookieName);

            if (authDataStr) {
                try {
                    const authData = JSON.parse(authDataStr);

                    if (authData && authData.token && authData.expiration > moment().valueOf()) {
                        return true;
                    }
                } catch (e) {}
            }

            return false;
        }
    }

    setAuth(authData) {
        // Example: { token: "5e196cc8b6cfb", expiration: "2020-01-11T09:35:52.000000Z" }
        authData.expiration = moment(authData.expiration).valueOf();
        JSCookie.set(this.cookieName, authData);
    }

    getAuthToken() {
        const authDataStr = JSCookie.get(this.cookieName);
        try {
            const authData = JSON.parse(authDataStr);
            if (authData && authData.token) {
                return authData.token;
            }
        } catch (e) {}
        return null;
    }

    clearAuth() {
        JSCookie.remove(this.cookieName);
    }

    getAuthDataStr() {
        return JSCookie.get(this.cookieName);
    }

    /**
     * @returns
     */
    async isParentMemberType() {
        const isLogged = this.isAuth();

        if (! isLogged) { return false; }

        const userData = (await UserService.getUserFrontendData()).data;
        const isChild  = userData.is_child;
        const memberTypeId = userData.member_type_id;

        // こどもアカウントの場合は無条件で FALSE
        if (isChild === true) { return false; }

        // いずれかのメンバータイプに一致で TRUE
        if ((memberTypeId === FORTHING_MEMBER_PARENT) ||
            (memberTypeId === GENERAL_FREE_MEMBER_PARENT) ||　
            (memberTypeId === FORTHING_MEMBER_SUPPORT_PARENT)
        ) {
            return true;
        }

        return false;
    }

    /**
     * @returns
     */
    async isChildMemberType() {
        const isLogged = this.isAuth();

        if (! isLogged) { return false; }

        const userData = (await UserService.getUserFrontendData()).data;
        const isChild  = userData.is_child;
        const memberTypeId = userData.member_type_id;

        // 子供アカウントではない場合は無条件で FALSE
        if (isChild !== true) { return false; }

        // いずれかのメンバータイプに一致で TRUE
        if ((memberTypeId === FORTHING_MEMBER_CHILD) ||
            (memberTypeId === GENERAL_FREE_MEMBER_CHILD) ||
            (memberTypeId === FORTHING_MEMBER_SUPPORT_CHILD)
        ) {
            return true;
        }

        return false;
    }

    /**
     * @return
     */
    async isAdvanceMemberType() {
        const isLogged = this.isAuth();

        if(! isLogged) { return false; }

        const userData = (await UserService.getUserFrontendData()).data;
        const memberTypeId = userData.member_type_id;

        // いずれかのメンバータイプに一致で TRUE
        if ((memberTypeId === FORTHING_MEMBER_PARENT) ||
            (memberTypeId === FORTHING_MEMBER_CHILD) ||
            (memberTypeId === FORTHING_MEMBER_SUPPORT_PARENT) ||
            (memberTypeId === FORTHING_MEMBER_SUPPORT_CHILD)
        ) {
            return true;
        }

        return false;
    }

    /**
     * @return
     */
    async isBasicMemberType() {
        const isLogged = this.isAuth();

        if(! isLogged) { return false; }

        const userData = (await UserService.getUserFrontendData()).data;
        const memberTypeId = userData.member_type_id;

        // いずれかのメンバータイプに一致で TRUE
        if ((memberTypeId === GENERAL_FREE_MEMBER_PARENT) ||
            (memberTypeId === GENERAL_FREE_MEMBER_CHILD)
        ) {
            return true;
        }

        return false;
    }

    async getMemberTypeName(memberTypeId = null) {
        const isLogged = this.isAuth();

        if(! isLogged) { return null; }

        if (! memberTypeId) {
            const userData = (await UserService.getUserFrontendData()).data;
            memberTypeId = userData.member_type_id;
        }

        switch(memberTypeId) {
            case FORTHING_MEMBER_PARENT:
            case FORTHING_MEMBER_CHILD:
            case FORTHING_MEMBER_SUPPORT_PARENT:
            case FORTHING_MEMBER_SUPPORT_CHILD:
                return 'advance';
            case GENERAL_FREE_MEMBER_PARENT:
            case GENERAL_FREE_MEMBER_CHILD:
                return 'basic';
            case PROGRESS_MEMBER_PARENT:
            case PROGRESS_MEMBER_CHILD:
                return 'progress';
            default:
                return null;
        }
    }

    async isProgressMemberType(memberTypeId = null) {
        const isLogged = this.isAuth();

        if(! isLogged) { return false; }

        if (! memberTypeId) {
            const userData = (await UserService.getUserFrontendData()).data;
            memberTypeId = userData.member_type_id;
        }

        // いずれかのメンバータイプに一致で TRUE
        if ((memberTypeId === PROGRESS_MEMBER_PARENT) ||
            (memberTypeId === PROGRESS_MEMBER_CHILD)
        ) {
            return true;
        }

        return false;
    }
}
